// extracted by mini-css-extract-plugin
export var column = "VideoCaption-module--column--9fc83";
export var companyLink = "VideoCaption-module--companyLink--0854b";
export var fadeInAnimation = "VideoCaption-module--fadeInAnimation--8cca8";
export var linkedinIcon = "VideoCaption-module--linkedinIcon--b2735";
export var position = "VideoCaption-module--position--1d164";
export var title = "VideoCaption-module--title--d6848";
export var videoDuration = "VideoCaption-module--videoDuration--d47bf";
export var wrapper = "VideoCaption-module--wrapper--19a76";